export interface AssessmentTranslations {
  cancel: string;
  clear: string;
  percentComplete: string;
  completedAt: string;
  submit: string;
  error: {
    failedToLoadAssessment: string;
    assessmentNotFound: string;
    assessmentInvalid: string;
  };
  loadingSurvey: string;
  loading: string;
  dirtyPrompt: string;
}

export const assessmentTranslationKeys: AssessmentTranslations = {
  cancel: 'cancel',
  clear: 'clear',
  percentComplete: 'percentComplete',
  completedAt: 'completedAt',
  submit: 'submit',
  error: {
    failedToLoadAssessment: 'error.failedToLoadAssessment',
    assessmentNotFound: 'error.assessmentNotFound',
    assessmentInvalid: 'error.assessmentInvalid',
  },
  loadingSurvey: 'loadingSurvey',
  loading: 'loading',
  dirtyPrompt: 'dirtyPrompt',
};

export const assessmentTranslationsEN: AssessmentTranslations = {
  cancel: 'Cancel',
  clear: 'Clear',
  percentComplete: 'Complete',
  completedAt: 'Completed At:',
  submit: 'Submit',
  error: {
    failedToLoadAssessment: 'Failed to load Assessment:',
    assessmentNotFound: 'Assessment not found.',
    assessmentInvalid: 'Assessment invalid, please contact',
  },
  loadingSurvey: 'Loading Survey, hang tight...',
  loading: 'Loading...',
  dirtyPrompt: 'Are you sure you want to close the form? Incomplete assessments will be lost.',
};

export const assessmentTranslationsES: AssessmentTranslations = {
  cancel: 'Cancelar',
  clear: 'Borrar',
  percentComplete: 'Completado',
  completedAt: 'Completado el:',
  submit: 'Enviar',
  error: {
    failedToLoadAssessment: 'No se pudo cargar la evaluación:',
    assessmentNotFound: 'Evaluación no encontrada.',
    assessmentInvalid: 'Evaluación inválida, por favor contacte',
  },
  loadingSurvey: 'Cargando encuesta, espere un momento...',
  loading: 'Cargando...',
  dirtyPrompt: '¿Está seguro de que desea cerrar el formulario? Las evaluaciones incompletas se perderán.',
};
